/// <reference path="DOMAttached.js" />

class GamePopup extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.buttons = this.el.querySelector('.buttonPane').querySelectorAll('input');

		for (let i = 0; i < this.buttons.length; i++) {
			if (this.options['button' + i] != "nolink") {
				this.safeObserve(this.buttons[i], 'click', (ev) => this.onButtonClick(ev, 'button' + i));
			}
		}
	}

	onButtonClick(ev, id) {
		GenericSoundsInstance.clickSound();
		ev.preventDefault();
		ev.stopPropagation();
		if (this.options[id] == "") {
			if (this.el.closest('.popupContainer') != undefined) {
				this.el.closest('.popupContainer').attachedObj.hidePopup();
			} else {
				this.el.closest('.animationContainer').attachedObj.hideAnimation();
			}
		} else {
			var textboxes = this.el.querySelectorAll('.textbox');
			var url = this.options[id];

			for (var i = 0; i < textboxes.length; i++) {
				var id = textboxes[i].id;
				url = url.replace('PLH_' + id.substr(id.lastIndexOf('_') + 1), encodeURIComponent(textboxes[i].querySelector("input").value));
			}

			this.el.closest('.tabbedApplication').attachedObj.loadPage(url);
		}
	}
}
